import React from "react";
import { DataGrid } from "@mui/x-data-grid";
import { GridContainer, TableTheme } from "./detailtableStyles";

const DetailTable = ({ rows, columns }) => {
  return (
    <GridContainer>
      <DataGrid
        rows={rows}
        rowHeight={50}
        autoHeight
        columns={columns}
        disableSelectionOnClick
        sx={TableTheme}
      />
    </GridContainer>
  );
};

export default DetailTable;
